import {
    GET_Q_SISE_SINISTER,
    GET_Q_SISE_SINISTER_PENDING,
    GET_Q_SISE_SINISTER_FULFILLED,
    GET_Q_SISE_SINISTER_REJECTED
} from '../actions/types';

  const initialState = {
    data: {},
    loading: false,
    error: false
  };

  export default function (state = initialState, action) {
    switch (action.type) {
      case GET_Q_SISE_SINISTER_PENDING:
        return {
          ...state,
          loading: true,
          error: false
        };
      case GET_Q_SISE_SINISTER_FULFILLED:
        return {
          ...state,
          data: {...state.data, ...action.payload},
          loading: false,
          error: false
      };
      case GET_Q_SISE_SINISTER_REJECTED:
        return {
          ...state,
          data: [],
          loading: false,
          error: true
        };
      case GET_Q_SISE_SINISTER:
        return {
          ...state,
          selected: action.payload
        };
      default:
        return state;
    }
  }